"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToDayNameString = transformDateToDayNameString;
function transformDateToDayNameString(date) {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][date.getDay()];
}
//# sourceMappingURL=transformDateToDayNameString.js.map